import FormattedMessage from 'I18n/components/FormattedMessage';
import { CopyInput } from 'foundations-components/transitional/components/CopyInput';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { LoadingSpinner as FoundationsLoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { HR } from 'foundations-components/transitional/components/HR';
import { ToolPreview } from './ToolPreview';
import { ShareToolFormContainer, ShareToolTabLeftSection, ShareToolTabRightSection } from './ShareToolLayout';
import { ShareToolTabFooter } from './ShareToolTabFooter';
import { ShareToolCloseButton } from './ShareToolCloseButton';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { trackInteraction } from '../../usage-tracker/track';
import { useLinkOrPdfShareTabContext } from '../../context/LinkOrPdfShareTabContext';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoadingSpinner = ({
  loadingMessage
}) => /*#__PURE__*/_jsx(Flex, {
  justifyContent: "center",
  blockSize: "40px",
  children: /*#__PURE__*/_jsx(FoundationsLoadingSpinner, {
    size: "xs",
    layout: "inline",
    label: loadingMessage || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.copyLink.defaultLoadingMessage"
    }),
    showLabel: true
  })
});
const CopyLinkAlert = ({
  failedAlertTitle,
  failedAlertMessage,
  onRetry
}) => /*#__PURE__*/_jsx(Alert, {
  use: "inline",
  type: "warning",
  titleText: failedAlertTitle,
  children: failedAlertMessage ? failedAlertMessage(onRetry) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.copyLink.defaultFailedAlert.message_jsx",
    elements: {
      Link: Button
    },
    options: {
      linkProps: {
        use: 'link',
        onClick: onRetry
      }
    }
  })
});
const PdfDownloadAlert = ({
  failedAlertTitle,
  failedAlertMessage,
  onRetry
}) => /*#__PURE__*/_jsx(Alert, {
  use: "inline",
  type: "warning",
  titleText: failedAlertTitle,
  children: failedAlertMessage ? failedAlertMessage(onRetry) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.downloadPdf.defaultFailedAlert.message_jsx",
    elements: {
      Link: Button
    },
    options: {
      linkProps: {
        use: 'link',
        onClick: onRetry
      }
    }
  })
});
export const LinkOrPdfShareTab = ({
  description,
  copyLinkProps,
  downloadPdfProps,
  previewComponent,
  previewScale
}) => {
  const {
    isCopyLinkLoading,
    isCopyLinkFailed,
    copyLink,
    fetchCopyLink,
    isPdfDownloading,
    isPdfDownloadFailed,
    isPdfDownloadSuccess,
    onPdfDownload
  } = useLinkOrPdfShareTabContext();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ShareToolTabLeftSection, {
      children: /*#__PURE__*/_jsxs(ShareToolFormContainer, {
        children: [/*#__PURE__*/_jsx("p", {
          children: description
        }), /*#__PURE__*/_jsx("div", {
          children: isCopyLinkLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
            loadingMessage: copyLinkProps.loadingMessage
          }) : isCopyLinkFailed ? /*#__PURE__*/_jsx(CopyLinkAlert, {
            failedAlertTitle: copyLinkProps.failedAlertTitle,
            failedAlertMessage: copyLinkProps.failedAlertMessage,
            onRetry: () => {
              fetchCopyLink();
              trackInteraction({
                action: 'retry copy link'
              });
            }
          }) : /*#__PURE__*/_jsx(CopyInput, {
            value: copyLink,
            buttonProps: {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.copyLink.inputText"
              }),
              tooltipPlacement: 'top',
              use: 'tertiary',
              hintSuccess: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.copyLink.success"
              }),
              onClick: () => {
                trackInteraction({
                  action: 'copy link'
                });
              }
            },
            inputProps: {
              onCopy: () => {
                trackInteraction({
                  action: 'copy link'
                });
              }
            }
          })
        }), downloadPdfProps && /*#__PURE__*/_jsx(HR, {}), downloadPdfProps && (isPdfDownloadFailed ? /*#__PURE__*/_jsx(PdfDownloadAlert, {
          failedAlertTitle: downloadPdfProps.failedAlertTitle,
          failedAlertMessage: downloadPdfProps.failedAlertMessage,
          onRetry: () => {
            onPdfDownload();
            trackInteraction({
              action: 'retry download pdf'
            });
          }
        }) : /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.downloadPdf.success"
          }),
          disabled: !isPdfDownloadSuccess,
          children: /*#__PURE__*/_jsx(LoadingButton, {
            use: "tertiary",
            onClick: () => {
              onPdfDownload();
              trackInteraction({
                action: 'download pdf'
              });
            },
            loading: isPdfDownloading,
            disabled: isPdfDownloading,
            failed: isPdfDownloadFailed,
            block: true,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "CommerceToolsUiLib.shareToolModal.linkOrPdfShareTab.downloadPdf.buttonText"
            })
          })
        }))]
      })
    }), /*#__PURE__*/_jsx(ShareToolTabRightSection, {
      children: /*#__PURE__*/_jsx(ToolPreview, {
        scale: previewScale,
        children: previewComponent
      })
    }), /*#__PURE__*/_jsx(ShareToolTabFooter, {
      children: /*#__PURE__*/_jsx(ShareToolCloseButton, {})
    })]
  });
};